const setupWelcomeTime = () => {
  const timeText = document.getElementById("time");
  if (!timeText) return;

  const today = new Date();
  const curHr = today.getHours();

  if (curHr < 12) {
    timeText.innerHTML = "Morning";
  } else if (curHr < 18) {
    timeText.innerHTML = "Afternoon";
  } else {
    timeText.innerHTML = "Evening";
  }
};

export default setupWelcomeTime;



// WEBPACK FOOTER //
// ./scripts/components/SetupWelcomeTime.js